import { useState } from "react";
import { router } from "@inertiajs/react";
import Header from "../Component/Header";

export default function Create() {
    const [form, setForm] = useState({
        kode: "",
        nama: "",
        metode: "",
        minimal: "",
        maksimal: "",
        biaya: "",
        pml_fee_type: "1",
        percent: "Percent",
        tipe: "DIRECT",
        logo: "",
        status: "Aktif",
        addition_tambahan_biaya: "",
        addition_jenis: "Nominal",
        addition_default_expired: "",
        addition_settlement: "H+1",
        guide_title: "",
        guide_payment_guide: "",
        data_status: "active",
    });
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    const setField = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

    const submit = async (event) => {
        event.preventDefault();
        setSubmitting(true);
        setErrors({});

        try {
            await window.axios.post("/panel/payment-method-lists", form, {
                headers: { Accept: "application/json" },
            });

            router.visit("/panel/payment-method-lists");
        } catch (error) {
            setErrors(error?.response?.data?.errors ?? {});
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <Header />
            <main id="content" className="pb-14 sm:pb-16">
                <div className="max-w-[85rem] px-4 sm:px-6 lg:px-8 mx-auto">
                    <div className="py-2 sm:pb-0 sm:pt-5 space-y-5">
                        <p className="text-sm text-muted-foreground-1">Payment Method List</p>

                        <form onSubmit={submit} className="grid grid-cols-1 lg:grid-cols-6 gap-5">
                            <div className="lg:col-span-5 space-y-4">
                                <div className="bg-card border border-card-line rounded-xl shadow-2xs overflow-hidden">
                                    <div className="py-3 px-5 border-b border-card-header">
                                        <h2 className="font-semibold text-foreground">Create Payment Method</h2>
                                    </div>

                                    <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
                                        {[
                                            ["kode", "Kode"],
                                            ["nama", "Nama"],
                                            ["metode", "Metode"],
                                            ["minimal", "Minimal"],
                                            ["maksimal", "Maksimal"],
                                            ["biaya", "Biaya"],
                                            ["percent", "Percent Type"],
                                            ["tipe", "Tipe"],
                                            ["logo", "Logo URL"],
                                            ["status", "Provider Status"],
                                            ["addition_tambahan_biaya", "Tambahan Biaya"],
                                            ["addition_jenis", "Addition Jenis"],
                                            ["addition_default_expired", "Default Expired"],
                                            ["addition_settlement", "Settlement"],
                                        ].map(([field, label]) => (
                                            <div key={field}>
                                                <label className="block mb-2 text-sm font-medium text-foreground">{label}</label>
                                                <input
                                                    type="text"
                                                    value={form[field]}
                                                    onChange={(e) => setField(field, e.target.value)}
                                                    className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                                />
                                                {errors[field] && <p className="mt-1 text-xs text-red-600">{errors[field]}</p>}
                                            </div>
                                        ))}

                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">Fee Type</label>
                                            <select
                                                value={form.pml_fee_type}
                                                onChange={(e) => setField("pml_fee_type", e.target.value)}
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                            >
                                                <option value="1">1. seller</option>
                                                <option value="2">2. buyer</option>
                                            </select>
                                            {errors.pml_fee_type && <p className="mt-1 text-xs text-red-600">{errors.pml_fee_type}</p>}
                                        </div>

                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">Data Status</label>
                                            <select
                                                value={form.data_status}
                                                onChange={(e) => setField("data_status", e.target.value)}
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                            >
                                                <option value="active">active</option>
                                                <option value="inactive">inactive</option>
                                            </select>
                                            {errors.data_status && <p className="mt-1 text-xs text-red-600">{errors.data_status}</p>}
                                        </div>

                                        <div className="md:col-span-2">
                                            <label className="block mb-2 text-sm font-medium text-foreground">Guide Title</label>
                                            <input
                                                type="text"
                                                value={form.guide_title}
                                                onChange={(e) => setField("guide_title", e.target.value)}
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                            />
                                            {errors.guide_title && <p className="mt-1 text-xs text-red-600">{errors.guide_title}</p>}
                                        </div>

                                        <div className="md:col-span-2">
                                            <label className="block mb-2 text-sm font-medium text-foreground">Payment Guide</label>
                                            <textarea
                                                rows={6}
                                                value={form.guide_payment_guide}
                                                onChange={(e) => setField("guide_payment_guide", e.target.value)}
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                            />
                                            {errors.guide_payment_guide && (
                                                <p className="mt-1 text-xs text-red-600">{errors.guide_payment_guide}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-end gap-2">
                                    <button
                                        type="button"
                                        onClick={() => router.visit("/panel/payment-method-lists")}
                                        className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-layer border border-layer-line text-layer-foreground"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={submitting}
                                        className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-primary border border-primary-line text-primary-foreground disabled:opacity-50"
                                    >
                                        {submitting ? "Saving..." : "Save Payment Method"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </>
    );
}
